<template>
  <div class="NsghMap">
    <div class="TopText">
      {{NsghMapData.title}}
    </div>
    <div class="Search">
      <FromComm :FromArr="FromArr" @YearChange='YearChange'></FromComm>
    </div>
    <div style="">
      <!-- margin-left: 240px; -->
      <div id="ChinaMap" ref="ChinaMap" style=" height: 700px;width  100%;z-index: 1;"></div>
    </div>
  </div>
</template>

<script>
// import ChinaMapData from "@/json/ChinaMap/ChinaMap.json";
import FromComm from '../../../../../../components/fromComponents/Commfrom/from-comm.vue'
export default {
  components: {
    FromComm
  },
  props: {
    NsghMapData: {
      type: Object,
      default() {
        return {
        }
      }
    },
    dataListHot: {
      type: Array,
      default() {
        return []
      }
    },
    FromArr: {
      type: Array,
      default() {
        return {
          
        }
      }
    }
  },
  data() {
    return {
      mapJson: undefined,
      mapData: undefined,
      areaCode: this.NsghMapData.areaCode,
      mapdata: [],
      pieces: [
        {

          gt: 40000000,
          label: "4000w+",
          color: "#001f97",
        },
        {
          gte: 35000000,
          lte: 40000000,
          // gt: ,
          label: "3500w~4000w",
          color: "#0034b5",
        },
        {
          gte: 30000000,
          lte: 35000000,
          // gt: ,
          label: "3000w~3500w",
          color: "#0052d9",
        },
        {
          gte: 25000000,
          lte: 30000000,
          // gt: ,
          label: "2500w~3000w",
          color: "#266fe8",
        },
        {
          gte: 20000000,
          lte: 25000000,
          // gt: ,
          label: "2000w~2500w",
          color: "#4787f0",
        },
        {
          gte: 12000000,
          lte: 20000000,
          // gt: ,
          label: "1200w~2000w",
          color: "#699ef5",
        },
        {
          gte: 8000000,
          lte: 12000000,
          // gt: ,
          label: "800w~1200w",
          color: "#96bbf8",
        },
        {
          gte: 2000000,
          lte: 8000000,
          label: "200w~800w",
          color: "#bbd3fb",
        },
        {
          gte: 500000,
          lt: 2000000,
          label: "50w~200w",
          color: "#d4e3fc",
        },
        {
          gte: 0,
          lt: 500000,
          label: "0~50w",
          color: "#ecf2fe",
        },
      ],

    }
  },
  created() { },
  mounted() {
  },
  activated() { },
  updated() { },
  methods: {
    initMap(dataList) {
      var myChart = this.$MyEcharts.init(document.getElementById('ChinaMap'));
      var ChinaMap = require("@/json/china.json"); //@/json/ChinaMap.json //显示所有中国地图南海区域 || @/json/china.json 不显示所有中国地图南海区域
      // this.$MyEcharts.registerMap('ChinaMap', ChinaMap);  //加载自定义边界数据地图
      this.$MyEcharts.registerMap('china', ChinaMap);  //加载自定义边界数据地图
      myChart.showLoading();
      let option = {
        title: {
          text: "",
          subtext: "",
          left: "center",
          textStyle: {
            color: "#fff",
            fontSize: 30,
          },
          subtextStyle: {
            fontSize: 20,
          },
        },
        // 热力地图
        visualMap: {
          min: 0,
          // max: 99999999999999999999999999999,
          left: 1,
          show: true, //图注
          realtime: true,
          // text: ['高', '低'],
          // calculable: true,

          inRange: {
            color: ["#ff8c71", "#7f1100"],
          },
          outOfRange: { //定义 在选中范围外 的视觉元素。
            color: ['#d2dae2'],
          },
          textStyle: {
            color: "#000",
          },
          pieces: this.pieces
        },

        tooltip: {
          trigger: 'item',
          showDelay: 0,
          backgroundColor: '#FFF',//浮框背景色
          transitionDuration: 0.2,
          formatter: function (params) {//设置提示框内的文字
            console.log(params, 'params');
            var p = '<h3 style="color:#000;text-align:center;font-size:20px;font-weight:bold;line-height:20px;">[' + params.name + ']</h3>' +
              '<p style="color:#f36d78;font-size:18px;margin-top: 30px;">销售额：' + params.data.value + '元</p>'
            return p;
          }
        },
        series: [
          {
            roam: true, // 禁止拖拽
            name: "",
            data: dataList,
            type: "map",
            mapType: "china",
            showLegendSymbol: false, // 存在legend时显示.
            // selectedMode: 'single',
            zoom: 1.2,
            aspectScale: 0.75,
            label: {
              // 默认文本标签样式
              normal: {
                color: "#000",
                show: true,
              },
              // 高亮文本标签样式
              emphasis: {
                color: "yellow",
                fontSize: 22,
                fontWeight: "bold",
              },
            },
            itemStyle: {
              // 默认区域样式
              normal: {
                // 区域背景透明
                borderColor: "#000",
                areaColor: "rgba(0, 255, 255, 0.5)",
                borderWidth: 1,
                shadowBlur: 10,
                shadowColor: "rgba(63, 218, 255, 0.5)"
              },
              // 高亮区域样式
              emphasis: {
                show: false,
                // 高亮区域背景色
                areaColor: "#f36d78",

              },
            },
            select: { // 地图选中区域样式
              label: { // 选中区域的label(文字)样式
                color: '#fff',
                fontSize: 22,
                fontWeight: "bold",
                color: "yellow",
              },
              itemStyle: {// 选中区域的默认样式
                areaColor: '#E34d59',
                shadowOffsetX: 0,
                shadowOffsetY: 1,

              },
            },
          },
        ],
      };
      myChart.setOption(option);
      myChart.hideLoading();
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    YearChange(e){
      this.$emit('YearChange',e)
    }
  },
  computed: {},
  watch: {
    dataListHot: {
      handler(newdataListHot, olddataListHot) {
        console.log(newdataListHot,'newdataListHot');
        let dataList = []
        if (newdataListHot) {
          newdataListHot.map((item, index) => {
            let obj = {
              name: item.Name,
              value: item.Value
            }
            dataList.push(obj)
          })
          this.initMap(dataList);
        }
        return dataList;
      }
    }
  },
}
</script>
<style scoped lang='less'>
.NsghMap {
  position: relative;
  padding-left: 75px;
  padding-bottom: 16px;

  .TopText {
    width: 100%;
    height: 50px;
    font-size: 24px;
    font-weight: bold;
    line-height: 70px;
    color: #1d2129;
    text-align: center;
    overflow: hidden;
    
    // outline: 1px solid red;
  }
  .Search{
    width: 240px;
    height: 200px;
    position: absolute;
    // outline: 1px solid red;
    z-index: 2;
  }
  .ChinaMap {
  }
}
</style>